
































import Vue from 'vue';
// import * as firebase from '@/plugins/firebase';
import { firebase } from 'mostra';
// import buyer from '@/modules/buyer/buyer';
// import company from '@/modules/buyer/company';
// import { v4 } from 'uuid';

export type DataType = {
  email: string;
  password: string;
}
export default Vue.extend({
  name: 'setting-auth-reset',
  data(): DataType {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    async onClickReset() {
      try {
        this.$loading(true);
        const email = this.email;
        const actionCodeSettings = {
          url:
            `${window.location.protocol}//${window.location.host}/web/auth/signin`,
          handleCodeInApp: true,
        };
        await firebase
          .auth()
          .sendPasswordResetEmail(email, actionCodeSettings);
        this.$success('リセットメールを送信しました');
      } catch (error: any) {
        this.$error('メール送信に失敗しました', error);
      } finally {
        this.$loading(false);
      }
    },
  },
});
